import List from 'containers/RolePermissions/List';
import Create from 'containers/RolePermissions/Create';
import Edit from 'containers/RolePermissions/Edit';

export default { List, Create, Edit };
